import {axiosInstance} from "./AxiosDefaults";
import {User} from "../models/User";

export let activeUser: User
try {
    activeUser = JSON.parse(<string>localStorage.getItem("rwa-user"))
} catch (error) {
    activeUser = {id: ''}
}

//TODO: remove next two lines, only for testing purposes
// activeUser = {id: 'administrator', firstName: 'Vladimir', lastName: 'Popov', role: 'administrator'};
//activeUser = {id: 'magacioner', firstName: 'Milan', lastName: 'Jovanovic', role: 'magacioner'};

export const getAccessToken = (username: string, password: any): Promise<any> => {
    return axiosInstance.post(
        `/auth/token`, // /mock/token`,
        {
            username: username,
            password: password
        },
        { withCredentials: false, headers: { 'Content-Type': 'application/json' } }
    );
}

export const setActiveUser = (user: User) => {
    activeUser = user
    localStorage.setItem("rwa-user", JSON.stringify(user))
}

export const removeActiveUser = () => {
    activeUser = {id: ""}
    localStorage.removeItem("rwa-user")
}
